import { initializeApp } from 'firebase/app';
import { getClientSettings } from '../services/Config';
import { isDefaultRoute, getDefaultFirebaseConfig } from '../helpers/Util';

const initialize = async () => {
  try {
    let settings = {};
    let firebaseConfig = getDefaultFirebaseConfig();

    if (!isDefaultRoute()) {
      settings = await getClientSettings();
      firebaseConfig = settings.auth.client.data;
    }

    initializeApp(firebaseConfig);

    return settings;
  } catch (err) {
    console.log('Error', err);
    throw new Error(err.message);
  }
};

export default initialize;
